import api from './api';

export interface StoreCustomerAccess {
  nroCliente: number;
  enabled: boolean;
  priceListId?: string | null;
  commercialPriceListId?: string | null;
  effectivePriceListId?: string | null;
  invitedAt?: string | null;
  activatedAt?: string | null;
  invitedEmail?: string | null;
  status: 'disabled' | 'enabled' | 'invited' | 'active' | string;
  email?: string | null;
  customerName?: string | null;
}

export interface StoreB2bAccessRequest {
  id: number;
  cuit: string;
  businessName: string;
  email: string;
  phone?: string | null;
  requestedNroCliente?: number | null;
  comment?: string | null;
  status: string;
  matchedNroCliente?: number | null;
  matchedCustomerName?: string | null;
  createdAt: string;
  resolvedAt?: string | null;
  resolvedBy?: string | null;
  resolutionNote?: string | null;
}

export interface UpdateStoreCustomerAccess {
  enabled: boolean;
  priceListId?: string | null;
}

export interface ApproveB2bAccessRequest {
  nroCliente?: number | null;
  priceListId?: string | null;
  sendInvite?: boolean;
  note?: string | null;
}

const storeCustomerAccessService = {
  getAccess: async (nroCliente: number): Promise<StoreCustomerAccess> => {
    const response = await api.get<StoreCustomerAccess>(`/api/Clientes/${nroCliente}/store-access`);
    return response.data;
  },

  upsertAccess: async (nroCliente: number, data: UpdateStoreCustomerAccess): Promise<StoreCustomerAccess> => {
    const response = await api.put<StoreCustomerAccess>(`/api/Clientes/${nroCliente}/store-access`, data);
    return response.data;
  },

  invite: async (nroCliente: number): Promise<void> => {
    await api.post(`/api/Clientes/${nroCliente}/store-access/invite`);
  },

  disable: async (nroCliente: number): Promise<StoreCustomerAccess> => {
    const response = await api.post<StoreCustomerAccess>(`/api/Clientes/${nroCliente}/store-access/disable`);
    return response.data;
  },

  listRequests: async (status?: string): Promise<StoreB2bAccessRequest[]> => {
    const response = await api.get<StoreB2bAccessRequest[]>('/api/Clientes/store-access-requests', {
      params: status ? { status } : undefined,
    });
    return response.data;
  },

  countPendingRequests: async (): Promise<number> => {
    const response = await api.get<{ count: number }>('/api/Clientes/store-access-requests/pending-count');
    return response.data.count;
  },

  approveRequest: async (id: number, data: ApproveB2bAccessRequest): Promise<void> => {
    await api.post(`/api/Clientes/store-access-requests/${id}/approve`, data);
  },

  rejectRequest: async (id: number, note?: string): Promise<void> => {
    await api.post(`/api/Clientes/store-access-requests/${id}/reject`, { note });
  },
};

export default storeCustomerAccessService;
